/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shopping_LeftInputs */

const en_shopping_left = /** @type {(inputs: Shopping_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} left`)
};

const de_shopping_left = /** @type {(inputs: Shopping_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} offen`)
};

/**
* | output |
* | --- |
* | "{count} left" |
*
* @param {Shopping_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_left = /** @type {((inputs: Shopping_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_left(inputs)
	return en_shopping_left(inputs)
});